import { render, staticRenderFns } from "./InvD_Profit.vue?vue&type=template&id=4daebbca"
import script from "./InvD_Profit.vue?vue&type=script&lang=js"
export * from "./InvD_Profit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports